
import { useAuth } from "../../context/AuthContext";
import PostByAgg, { downloadFileFromApi, PostFormDataByAgg } from '../../utils/axios'
import DataTableLayer from '../../components/DataTableLayer'
import { useCallback, useEffect, useState } from "react";
import ModalAlert from "../../components/ModalAlert";
import LottieLoading from "../../components/child/LottieLoading";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const Payment = () => {
    const [payment ,setPayment] = useState([]);
    const [pagination,setPagination] = useState({
        pageIndex:0,
        pageSize:0,
        totalRecords:0,
        totalPages:0,
    })
    const [modalOpen,setModalOpen] = useState(<div></div>)
    const [isLoading, setIsLoading] = useState(false);
    const {musicLabelCode,musicLabelName} = useAuth();
    const [selectedDate, setSelectedDate] = useState(null);

    const [musicLabelCodeFilter, setMusicLabelCodeFilter] = useState('');
  const [musicLabelNameFilter, setMusicLabelNameFilter] = useState('');
  const [paymentDateFilter, setPaymentDateFilter] = useState(null);

    const columns = [
        {
            accessorKey : 'music_label_name',
            header: 'Nama Label',
        },
        {
            accessorKey:'song_name',
            header:'Nama Lagu'
        },
        {
            accessorKey: 'release_name',
            header: 'Nama rilis'
        },
        {
            accessorKey: 'bank',
            header: 'Nama Bank'
        },
        {
            accessorKey: 'bank_account_name',
            header: 'Akun Bank'
        },
        {
            accessorKey:'period',
            header:'periode'
        },
        {
            accessorKey:'amount',
            header:'Jumlah'
        },
        // {
        //     accessorKey:'start_date',
        //     header:'Tanggal Mulai'
        // },
        // {
        //     accessorKey:'payment_date',
        //     header: 'Tanggal Bayar'
        // },
        {
            accessorKey: 'payment_date',
            header: 'Tanggal Bayar',
            cell: ({ row }) => {
                const paymentDate = row.getValue('payment_date');
                return (
                    <span>{paymentDate ? paymentDate : 'N/A'}</span>
                );
            }
        },
        {
            accessorKey:'status_name',
            header:'Status',
            cell: ({row}) => {
                const status = row.getValue('status_name');
                let badgeColor;
                if (status === 'Pending') {
                    badgeColor = 'bg-warning';
                }else {
                    badgeColor = 'bg-success';
                }
                return (
                    <span className={`badge ${badgeColor}`}>{status}</span>
                  );
            }
        },
        // {
        //     accessorKey:"download",
        //     header: 'download',
        //     cell:({row}) => (
        //         <div>
        //             <span className="btn px-18 py-2 bg-primary-light" onClick={()=> handleRowDownload('download',row.original)}>Download</span>
        //         </div>
        //     )
        // }
    ]


    // const handleDownload = () => {
    //     const headers = columns.map(col => col.header).filter(Boolean);
    //     const rows = payment.map(row => {
    //       return columns.map(col => {
    //         const key = col.accessorKey;
    //         return row[key] !== undefined ? row[key] : '';
    //       });
    //     });
      
    //     const csvContent = [
    //       headers.join(','),
    //       ...rows.map(row => row.join(','))
    //     ].join('\n');
      
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement("a");
    //     link.setAttribute("href", url);
    //     link.setAttribute("download", `payment_page.csv`);
    //     link.click();
    //   };

    const handleDateChange = (date) => {
    setSelectedDate(date); // update selected date
    console.log(date);
  };

    const GetListPayment = () => {
        setIsLoading(true);
        const url = 'song/v1/payment/list'
        PostByAgg({
            url:url,
            body:{
                "keyword" : "",
                "page" : pagination.pageIndex + 1,
                "page_size" : pagination.totalRecords,
                "music_label_code" : musicLabelCode,
                "music_label_name": musicLabelNameFilter,
            },
            onResponse : onResponseListPayment,
            onError: onErrorListPayment
        })
    };

    const onResponseListPayment = (response) => {
        console.log("response payment",response.data.data)
        if(response.data.code === '2002000' || response.data.data === null){
          const totalRecords = response.data.data.total_records;
          const totalPages = Math.ceil(totalRecords / pagination.pageSize);
          setPagination((prev) => ({
              ...prev,
              totalRecords: totalRecords,
              totalPages: totalPages,
              pageSize: totalRecords,
              // pageIndex: 0,
            }));
            setIsLoading(false)
            setPayment(response.data.data?.data || [])
        }else{
            setIsLoading(false)
            setPayment([])
        }
    }

    const onErrorListPayment = (error) => {
        setIsLoading(false);
        setModalOpen(
            <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data}
                action={()=>{}}
            />
        )
    }

  const handleDownload = async (row) => {
  const url = 'song/v1/payment/download'; 
  const body = {
    keyword: "",
    page: 1,
    page_size: 5,
    music_label_code: musicLabelCode,
    music_label_name: musicLabelName,
    payment_date: row.selectedDate
  };

  const fileName = 'payment.xlsx'; 

  downloadFileFromApi({
    url: url,
    body: body,
    fileName: fileName,
    onResponse: (response) => {
      console.log('File downloaded successfully', response);
    },
    onError: (error) => {
      console.log('Error downloading file:', error);
    }
  });
};
    

 useEffect(() =>{
    GetListPayment()
 },[pagination.pageIndex, pagination.pageSize])

  return (
    <div>
        <DataTableLayer 
        data={payment} 
        columns={columns} 
        showButton={true} 
        btnTitle={"Download"}
        onClick={handleDownload}
        className={"bg-success"}
        />
        {isLoading && <LottieLoading text="Loading..." />}
        {modalOpen}
    </div>
  )
}

export default Payment